import { TranslateService } from "@ngx-translate/core";
import { ConfirmationService, MessageService } from "primeng/api";

export const LANGUAGES = [
  { value: "it", label: "Italiano" },
  { value: "en", label: "English" },
  { value: "de", label: "Deutsch" },
];

let translator: TranslateService | null = null;

/** Called once at startup so plain TypeScript (constants, menus, messages) can translate too. */
export function setTranslator(service: TranslateService): void {
  translator = service;
}

/** translation entries live under "t", keyed by the Italian text (dots are escaped for ngx-translate) */
function keyOf(text: string): string {
  return "t." + text.replace(/\./g, "․");
}

/**
 * Translates an Italian source text into the current language; the text itself is the fallback,
 * so a missing entry shows Italian instead of a key.
 */
export function tr(text: string, params?: Record<string, string | number>): string {
  if (!text) return text;
  let out = text;
  if (translator) {
    const key = keyOf(text);
    const value = translator.instant(key);
    if (value && value !== key) {
      out = value;
    } else if (text.includes(" = ")) {
      // "Sei sicuro di volerlo cancellare = <name>": translate the fixed part only
      const at = text.indexOf(" = ");
      out = tr(text.slice(0, at)) + text.slice(at);
    }
  }
  return params ? out.replace(/\{(\w+)\}/g, (_, name) => String(params[name] ?? "")) : out;
}

/** A select option whose label follows the current language. */
export function opt<V>(text: string, value: V): { label: string; value: V } {
  return {
    get label() {
      return tr(text);
    },
    value,
  };
}

/** Every toast and confirmation popup is translated in one place instead of at each call site. */
export function translatePopups(): void {
  const add = MessageService.prototype.add;
  MessageService.prototype.add = function (message: any) {
    return add.call(this, { ...message, summary: tr(message.summary), detail: tr(message.detail) });
  };
  const confirm = ConfirmationService.prototype.confirm;
  ConfirmationService.prototype.confirm = function (confirmation: any) {
    return confirm.call(this, {
      ...confirmation,
      message: tr(confirmation.message),
      header: tr(confirmation.header),
      acceptLabel: tr(confirmation.acceptLabel),
      rejectLabel: tr(confirmation.rejectLabel),
    });
  };
}
